import React from 'react';

import { Dropdown, DropdownMenu, DropdownToggle, NavLink } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const NavDropdown = props => (
  <Dropdown id={props.id} data-cy={props['data-cy']}>
    <DropdownToggle as={NavLink} className="d-flex align-items-center">
      <FontAwesomeIcon icon={props.icon} />
      <span>{props.name}</span>
    </DropdownToggle>
    <DropdownMenu align="end" style={props.style}>
      {props.children}
    </DropdownMenu>
  </Dropdown>
);
